import axios from "axios"
import { post, del, get, put } from "./api_helper"
import * as url from "./url_helper"

// Create course
export const createExam = data => post(url.CREATE_EXAM, data);
export const getAllExamsOfBatch = id => get(url.GET_ALL_EXAM_OF_BATCH + id);
export const downloadExamReport = id => get(url.DOWNLOAD_EXAM_REPORT + id);
export const deleteExam = id => del(url.DELETE_EXAM + id);
export const getResult = id => get(url.GET_RESULT + id);

// New function for updating exam status
export const updateExamStatus = (examId, status) => 
    post(`${url.UPDATE_EXAM_STATUS}${examId}/${status}`, {});